import { render, staticRenderFns } from "./VideoBig.vue?vue&type=template&id=4985d98e&scoped=true&"
import script from "./VideoBig.vue?vue&type=script&lang=js&"
export * from "./VideoBig.vue?vue&type=script&lang=js&"
import style0 from "./VideoBig.vue?vue&type=style&index=0&id=4985d98e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4985d98e",
  null
  
)

export default component.exports